/**
 * Scroll active product thumbnail into view (many images).
 */
function scrollActiveProductThumb() {
  const gallery = document.querySelector('.product--espace-gallery media-gallery');
  if (!gallery) return;

  const list = gallery.querySelector('.thumbnail-list');
  if (!list) return;

  const activeBtn = list.querySelector('button[aria-current="true"]');
  if (!activeBtn) return;

  const item = activeBtn.closest('.thumbnail-list__item') || activeBtn.parentElement;
  if (!item) return;

  const listRect = list.getBoundingClientRect();
  const itemRect = item.getBoundingClientRect();

  if (itemRect.top < listRect.top || itemRect.bottom > listRect.bottom) {
    item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
}

function initEspaceProductGallery() {
  const gallery = document.querySelector('.product--espace-gallery media-gallery');
  if (!gallery || gallery.dataset.espaceGalleryInit) return;
  gallery.dataset.espaceGalleryInit = 'true';

  gallery.addEventListener('click', (e) => {
    if (e.target.closest('.thumbnail-list button')) {
      window.setTimeout(scrollActiveProductThumb, 80);
    }
  });

  const viewer = gallery.querySelector('[id^="GalleryViewer"]');
  if (viewer) {
    viewer.addEventListener('slideChanged', () => {
      window.setTimeout(scrollActiveProductThumb, 80);
    });
  }

  scrollActiveProductThumb();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initEspaceProductGallery);
} else {
  initEspaceProductGallery();
}

document.addEventListener('shopify:section:load', initEspaceProductGallery);
